import { Button } from "@/components/ui/button";

interface Category {
  value: string;
  label: string;
}

interface CategorySelectorProps {
  categories: Category[];
  selectedCategory: string;
  onCategorySelect: (category: string) => void;
}

export const CategorySelector = ({
  categories,
  selectedCategory,
  onCategorySelect,
}: CategorySelectorProps) => {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <Button
          key={cat.value}
          variant={selectedCategory === cat.value ? "default" : "outline"}
          size="sm"
          className={`
            ${selectedCategory === cat.value 
              ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600' 
              : 'hover:bg-purple-50 border-purple-200'
            } 
            rounded-full transition-all duration-200 transform hover:scale-105
          `}
          onClick={() => onCategorySelect(cat.value)}
        >
          {cat.label}
        </Button>
      ))}
    </div>
  );
};